export const MY_CHIP_DATA = "my-chip-data";
export const OPERATE_CHIP = "operate-chip";
export const OPERATE_MQTT = "operate-mqtt";
